<template lang="pug">
.change-data-container(@click="expand = !expand")
  .change-data
    .menu-icon-change.relative(@click.stop="" style="order: -1;")
      img(:src="require('@/assets/menu.svg')" alt="menu" @click="showMenu")
      transition(name="opacity-bottom")
        shMenuChange(v-if="showedMenu" @copyDataSky="copyDataSky" @copyDataExcel="copyDataLocal" :index="indexMenu")

    .change-number
      span.material-symbols-outlined(:class="`color-${data.brand}`") swap_horiz
      span.tag(:class="`bg-${data.brand}`") c{{ data.change }}

    .change-order
      span.material-symbols-outlined(:class="`color-${data.brand}`") shopping_cart
      span.tag(:class="`bg-${data.brand}`") {{ data.order }}

    .change-status(v-if="!history")
      .tag(:style="styleStatus") {{ data.status }}

    .change-name.capitalize(v-if="!history") {{ name(data.name) }}

    .change-location.capitalize(v-if="!history") {{ cutValue(data.location) }}

    .change-phone(v-if="!history") {{ data.phones && data.phones[0] }}

    .change-date {{ dateName(data.createdAt) }} - {{ time(data.createdAt) }}

    .change-remit(v-if="!history" @click.stop="")
      RemitDataIcon(:record="data")

    .change-reasons(v-if="!history && data.reasons && data.reasons.length") {{ reasonsToText(data.reasons) }}

    .change-collected(v-if="!history && data.collectedValue") {{ money(data.collectedValue) }}

    .change-history.capitalize(v-if="history" :class="colorTransaction(data.transaction)") {{ data.transaction }}d

  .change-actions-container(@click.stop="")
    .change-actions
      .notifications(v-if="data.status !== 'declined'")
        img.disabled(:src="require('@/assets/notifications.svg')" alt="notifications")

      .undo(v-if="data.status !== 'created'")
        img(v-if="action && action.previousAction" :src="require('@/assets/undo.svg')" :alt="`undo-${data.status}`" @click="undoAction" :class="{disabled: isLoading}")
      .undo(v-else-if="data.status === 'created'")
        img(v-if="action && action.previousAction" :src="require('@/assets/times.svg')" :alt="`undo-${data.status}`" @click="undoAction" :class="{disabled: isLoading}")
      .undo(v-else)

      .buttons-actions
        shActionButton(v-if="action && action.nextAction" :action="action.nextAction" :params="[data.change]" :text="sendActionText" :textRunning="sendActionTextRunning" width="9rem" :textConfirmation="sendConfirmation")
        SendSkipGuideToggle(v-if="canSkipGuide" v-model="skipGuide")

    .container-checkbox-change
      shCheckbox(v-model="checked")

  transition(name="slide-fade")
    shForm.list-change(v-if="expand && !history" :dataOriginal="data" :fillData="true" @click.native.stop="")

  transition(name="slide-fade")
    shHistory.list-change(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)" @click.native.stop="")

  .subcontainer(v-if="data.status !== 'declined'")
    .container-received
      span.data-received(v-if="data.packReceived")
        span Paquete Recibido:
        shNameUser(:dni="data.packReceivedBy")
        span - {{ dateName(data.packReceivedAt) }}
      span(v-else) Esperar Paquete: {{ data.waitPackage ? 'Sí' : 'No' }}
      shActionButton(v-if="!data.packReceived" :action="receivePackage" :params="[data.change]" text="Recibir" textRunning="Recibiendo" :mini="true")
      shActionButton(v-else :action="unreceivePackage" :params="[data.change]" text="Eliminar Recibido" textRunning="Eliminando Recibido" :mini="true")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlChange from '@/graphql/change'
import gql from '@my/graphql'
import shNameUser from '@/components/elements/NameUser'
import shCheckbox from '@/components/elements/Checkbox'
import shMenuChange from './MenuChange'
import RemitDataIcon from '@/components/elements/remit/RemitDataIcon.vue'
import SendSkipGuideToggle from '@/components/elements/order/SendSkipGuideToggle.vue'

export default {
  name: 'Change',

  mixins: [mFilters, mForm],

  components: { shForm, shHistory, shNameUser, shCheckbox, shMenuChange, RemitDataIcon, SendSkipGuideToggle },

  props: {
    data: Object,
    index: Number,
    realIndex: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      animationCopy: false,
      indexMenu: -1,
      isLoading: false,
      skipGuide: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    copyDataLocal () {
      let csv = ''

      const { change, address, location, department, phones, methodPay, name, brand } = this.data

      const date = new Date()
      const dateFormatted = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`

      csv = `${dateFormatted}\tc${change}\t${brand}\t${address}\t${location} - ${department}\t${name}\t${phones.join(', ')}\t${methodPay === 'cod' || this.totalCOD > 0 ? 'Sí' : 'No'}\t${this.totalCOD > 0 ? this.totalCOD : 0}`

      const csvNoEnter = csv.replace(/\n/g, '')
      this.copyNavigator(csvNoEnter)

      modals.showMessage({ message: 'Se copió la orden para Excel' })
    },

    copyDataSky () {
      let csv = ''

      const { address, location, department, phones, methodPay, name, email } = this.data

      const total = this.totalCOD

      csv = `${name}\t${email}\t${phones[0]}\t${address.replace(/\t/g, '')}\t(${location} - ${department})\tconfeccion\t${parseInt(total / 2)}\t${total}\t${methodPay}`

      const csvNoEnter = csv.replace(/\n/g, '')
      this.copyNavigator(csvNoEnter)

      modals.showMessage({ message: 'Se copió la orden para Skydropx' })
    },

    copyNavigator (text) {
      try {
        this.animationCopy = true
        const type = 'text/plain'
        const blob = new Blob([text], { type })
        const data = [new window.ClipboardItem({ [type]: blob })]
        navigator.clipboard.write(data)

        setTimeout(() => { this.animationCopy = false }, 200)
      } catch (error) {
        console.log('Característica sólo soportada en Chrome')
      }
    },

    name (value) {
      if (!value) return value
      const names = value.split(' ')
      return names[0] || names[1]
    },

    cutValue (value) {
      if (!value) return value
      const maxLength = 8
      return value.slice(0, maxLength) + (value.length > maxLength ? '...' : '')
    },

    async showMenu () {
      if (this.showedMenu) {
        this.hideMenu()
        return
      }
      if (this.indexMenu !== -1) {
        this.$store.commit('showMenu', this.indexMenu)
        return
      }
      this.indexMenu = await this.$store.dispatch('setMenu')
    },

    hideMenu () {
      this.$store.commit('hideMenu', this.indexMenu)
    },

    async undoAction () {
      if (this.isLoading) return
      try {
        this.isLoading = true
        const action = this.action.previousAction
        action(this.data.change)
      } catch (error) {
        console.log(error)
      } finally {
        setTimeout(() => { this.isLoading = false }, 500)
      }
    },

    async receivePackage (change) {
      const mutation = gqlChange.RECEIVE_PACKAGE

      if (!change) return

      const response = await gql.mutate(mutation, { change, sendNotifications: false })

      if (response) modals.showMessage({ message: `Se recibió el paquete del cambio ${change} correctamente` })
    },

    async unreceivePackage (change) {
      const mutation = gqlChange.UNRECEIVE_PACKAGE

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se borró recibido del paquete del cambio ${change} correctamente` })
    },

    async declineChange (change) {
      const mutation = gqlChange.DECLINE

      if (!change) return

      const response = await gql.mutate(mutation, { change, sendNotifications: false })

      if (response) modals.showMessage({ message: `Se declinó el cambio ${change} correctamente` })
    },

    async approveChange (change) {
      const mutation = gqlChange.APPROVE

      if (!change) return

      const response = await gql.mutate(mutation, { change, sendNotifications: false })

      if (response) modals.showMessage({ message: `Se aprobó el cambio ${change} correctamente` })
    },

    async disapproveChange (change) {
      const mutation = gqlChange.DISAPPROVE

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se desaprobó el cambio ${change} correctamente` })
    },

    async payChange (change) {
      const mutation = gqlChange.PAY

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se pagó el cambio ${change} correctamente` })
    },

    async deletePayChange (change) {
      const mutation = gqlChange.DELETE_PAY

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se eliminó el pago del cambio ${change} correctamente` })
    },

    async packChange (change) {
      const mutation = gqlChange.PACK

      if (!change) return

      const response = await gql.mutate(mutation, { change, sendNotifications: false })

      if (response) modals.showMessage({ message: `Se empacó el cambio ${change} correctamente` })
    },

    async unpackChange (change) {
      const mutation = gqlChange.UNPACK

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se desempacó el cambio ${change} correctamente` })
    },

    async sendChange (change) {
      const mutation = gqlChange.SEND

      if (!change) return

      const response = await gql.mutate(mutation, { change, sendNotifications: false, skipGuide: this.skipGuide })

      if (response) modals.showMessage({ message: `Se envió el cambio ${change} correctamente` })
    },

    async backSendChange (change) {
      const mutation = gqlChange.BACK_SEND

      if (!change) return

      const response = await gql.mutate(mutation, { change })

      if (response) modals.showMessage({ message: `Se devolvió el envío del cambio ${change} correctamente` })
    },

    reasonsToText (reasons) {
      if (!reasons || !reasons.length) return ''

      const reasonObj = {
        11: 'Cliente: Eligió mal talla',
        12: 'Cliente: No gustó material',
        13: 'Cliente: No gustó prenda',
        14: 'Cliente: No gustó color',
        21: 'Sahet: Talla incorrecta',
        22: 'Sahet: Referencia incorrecta',
        23: 'Sahet: Color no coincide con la imagen',
        24: 'Sahet: Producto defectuoso',
        25: 'Sahet: Error asesor al hacer la orden',
        26: 'Sahet: Mal etiquetado'
      }

      return reasons.reduce((text, reason) => {
        if (!reasonObj[reason]) return text
        if (!text) return reasonObj[reason]
        return text + ', ' + reasonObj[reason]
      }, '')
    }
  },

  computed: {
    showedMenu () {
      return this.$store.state.interface.menus[this.indexMenu]
    },

    action () {
      const actions = {
        declined: {
          previousAction: null,
          nextAction: null,
          text: '',
          textRunning: ''
        },
        created: {
          previousAction: this.declineChange,
          nextAction: this.approveChange,
          text: 'Aprobar',
          textRunning: 'Aprobando'
        },
        approved: {
          previousAction: this.disapproveChange,
          nextAction: this.payChange,
          text: 'Pagar',
          textRunning: 'Pagando'
        },
        paid: {
          previousAction: this.deletePayChange,
          nextAction: this.packChange,
          text: 'Empacar',
          textRunning: 'Empacando'
        },
        packed: {
          previousAction: this.unpackChange,
          nextAction: this.sendChange,
          text: 'Enviar',
          textRunning: 'Enviando',
          textConfirmation: '¿Deseas enviar el cambio?'
        },
        sent: {
          previousAction: this.backSendChange,
          nextAction: null,
          text: '',
          textRunning: ''
        }
      }
      return actions[this.data.status]
    },

    canSkipGuide () {
      return this.data.status === 'packed' && !!(this.action && this.action.nextAction)
    },

    sendActionText () {
      if (this.canSkipGuide && this.skipGuide) return 'E. Sin Guía'
      return this.action && this.action.text
    },

    sendActionTextRunning () {
      if (this.canSkipGuide && this.skipGuide) return 'Enviando sin guía'
      return this.action && this.action.textRunning
    },

    sendConfirmation () {
      if (this.data.status !== 'packed') return this.action && this.action.textConfirmation
      return this.skipGuide
        ? '¿Deseas enviar el cambio sin guía?'
        : '¿Deseas enviar el cambio?'
    },

    styleStatus () {
      if (!this.colorsStatus[this.data.status]) return ''
      return `background: ${this.colorsStatus[this.data.status].background}; color: ${this.colorsStatus[this.data.status].color}`
    },

    checked: {
      get () {
        if (this.$store.state.data.changes.data.docs[this.realIndex] === undefined) return false
        return this.$store.state.data.changes.data.docs[this.realIndex].checked
      },
      set (value) {
        this.$store.commit('changeCheckItem', { resolver: 'changes', index: this.realIndex, value })
      }
    },
    totals () {
      return this.getTotals(this.data.cart)
    },

    total () {
      return this.total(this.data, this.totals)
    },

    discount () {
      if (!this.data.codeName) return 0
      if (this.data.codeType === 'percent') {
        return this.total * this.data.codePercent / 100
      } else {
        return this.data.codeValue
      }
    },

    addons () {
      return (this.data.tip || 0) + (this.data.methodPayCost || 0) + (this.data.conveyorCost || 0)
    },

    totalCOD () {
      const change = this.data
      const { payManual } = change
      let total = 0

      for (let i = 0; i < payManual.length; i++) {
        const pay = payManual[i]

        if (pay.methodPay === 'cod') total += pay.value || 0
      }

      return total
    }
  }
}
</script>

<style lang="stylus">
.change-data-container
  display flex
  flex-direction row
  border-top 1px solid rgba(0, 0, 0, .2)
  padding 1.5rem 0rem
  align-items flex-start
  flex-wrap wrap
  gap 1em
  justify-content space-between

.change-data
  font-size 1.2rem
  display flex
  align-items center
  cursor pointer
  flex-basis calc(100% - 3rem)
  flex-shrink 0
  text-align left
  flex-wrap wrap
  column-gap 1em
  padding 0 1rem

.menu-icon-change img
  height 1em
  cursor pointer
  position relative
  top .1em

.change-actions .undo
  flex-basis 1em
  flex-shrink 0
  height 1.1em

.change-actions img
  height 1.3em
  display block
  cursor pointer

.change-actions img.disabled
  opacity .2

.undo img
  height 1.1em
  cursor pointer

.undo img.disabled
  opacity .2
  cursor default

.change-number, .change-order
  display flex
  align-items center
  gap .5em

.change-number .material-symbols-outlined, .change-order .material-symbols-outlined
  font-size 1.4em

.change-actions-container
  display flex
  align-items center
  gap 1.5rem
  padding 0 1rem

.container-checkbox-change
  display flex
  align-items center
  gap 1em
  flex-basis 1em
  flex-shrink 0
  margin-top .3em

.change-actions
  display flex
  align-items center
  gap 1em

.copy-buttons
  display flex
  gap .5em

.list-change
  flex-basis 100%
  flex-shrink 0
  width 100%

.subcontainer
  flex-basis 100%
  padding 0 1rem
  opacity .5

.subcontainer:hover
  opacity 1

.container-received
  display flex
  gap 1em
  align-items center
  font-size 1.1rem

.data-received
  display flex
  gap .5em
  align-items center

@media (pointer: fine)
  .change-data
    flex-basis calc(100% - 16rem - 5rem)
    column-gap 0
    row-gap 1em

  .menu-icon-change
    flex-basis 2em

  .change-number
    width 8em
  .change-order
    width 8em
  .change-status
    width 7em
  .change-name
    width 8em
  .change-location
    width 8em
  .change-phone
    width 8em
  .change-date
    width 10em
  .change-reasons
    width 12em
  .change-collected
    width 8em
  .change-actions
    width 16rem

  .change-actions-container
    padding 0
</style>



// WEBPACK FOOTER //
// src/components/pages/change/Change.vue